(function ($, utils) {
	$(function () {
		var $slider = $('.mainSlider'),
			$inner = $('.box_blockMain .box__inner'),
			width = $(window).width(),
			height = $(window).height(),
			headerH = $('.header__left').height();

		var isMobile = function($width, $height) {
			if (app.sizes.width < app.mobileTo) {
				$inner.height($height - headerH);
				$slider.height('90%');
			} else {
				$slider.height($width*0.3140625);
				$inner.height('66vh');
			}
		};

		isMobile(width, height);

		// $(window).on('resize', function() {
		// 	var width = $(window).width(),
		// 		height = $(window).height(),
		// 		headerH = $('.header__left').height();

		// 	isMobile(width, height);
		// });

		var swiper = new Swiper('.mainSlider .swiper-container', {
			pagination: '.mainSlider .swiper-pagination',
			paginationClickable: true,
			updateOnImagesReady: true,
			paginationBulletRender: function (swiper, index, className) {
				return '<span class="swiper-pagination-bullet"><svg class="icon__slideNav-item" width="21px" height="22px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#slideNav-item"></use></svg></span>';
			},
			loop: false,
			autoplay: 9000,
			nextButton: '.mainSlider .swiper-button-next',
			prevButton: '.mainSlider .swiper-button-prev',
			effect: 'fade',
			onInit: function(){
				app.utils.slidePreview('.mainSlider', 1);
			},
			onSlideChangeEnd: function(){
				app.utils.slidePreview('.mainSlider', 1);
			}
		});
	});
})(jQuery, app.utils);